import React from 'react';
import Wrapper from '../components/Wrapper/Wrapper';

const CookieSettings = () => {
    return (
        <Wrapper>
            <div style={{ marginBottom: '4em' }}>
                <p><strong>Impostazioni dei Cookie su Rossomotori.it</strong></p>

                <p><strong>1. Introduzione</strong></p>
                <p>Rossomotori.it (“Sito”) consente agli utenti di gestire le preferenze relative ai cookie utilizzati durante la navigazione. Questa pagina spiega come configurare le impostazioni dei cookie per garantire un utilizzo consapevole e personalizzato del Sito.</p>

                <p><strong>2. Gestione delle Preferenze</strong></p>
                <p>Gli utenti possono scegliere quali categorie di cookie accettare o rifiutare tramite il banner dei cookie mostrato al primo accesso al Sito o tramite la sezione "Impostazioni Cookie" disponibile in ogni momento.</p>

                <p><strong>3. Tipologie di Cookie Gestibili</strong></p>
                <ul>
                    <li><strong>Cookie Necessari:</strong> Non possono essere disabilitati in quanto garantiscono il funzionamento del Sito (es. autenticazione e sicurezza).</li>
                    <li><strong>Cookie di Prestazione:</strong> Possono essere accettati o rifiutati e servono per raccogliere dati anonimi sull’utilizzo del Sito.</li>
                    <li><strong>Cookie di Funzionalità:</strong> Consentono di personalizzare l’esperienza utente (es. lingua o layout preferiti).</li>
                    <li><strong>Cookie di Profilazione:</strong> Utilizzati per scopi pubblicitari e di marketing mirato; possono essere disabilitati dagli utenti.</li>
                    <li><strong>Cookie di Terze Parti:</strong> Impostati da servizi esterni integrati nel Sito, come social media o strumenti di analisi.</li>
                </ul>

                <p><strong>4. Come Modificare le Impostazioni</strong></p>
                <p>Gli utenti possono:</p>
                <ul>
                    <li><strong>Accedere al Banner dei Cookie:</strong> Fare clic sul pulsante "Impostazioni Cookie" nel banner mostrato al primo accesso.</li>
                    <li><strong>Utilizzare la Sezione Dedicata:</strong> Accedere alla sezione "Impostazioni Cookie" disponibile nel footer del Sito.</li>
                    <li><strong>Configurare il Browser:</strong> Gestire o bloccare i cookie direttamente tramite le impostazioni del browser utilizzato (es. Chrome, Firefox, Safari).</li>
                </ul>

                <p><strong>5. Browser Supportati per la Gestione dei Cookie</strong></p>
                <ul>
                    <li><a href="https://support.google.com/chrome/answer/95647?hl=it&co=GENIE.Platform%3DDesktop">Google Chrome: Guida</a></li>
                    <li><a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie">Mozilla Firefox: Guida</a></li>
                    <li><a href="https://support.apple.com/it-it/guide/safari/ibrw850f6c51/mac">Safari: Guida</a></li>
                    <li><a href="https://support.microsoft.com/it-it/windows/gestire-i-cookie-in-microsoft-edge-visualizzare-consentire-bloccare-eliminare-e-usare-168dab11-0753-043d-7c16-ede5947fc64d#:~:text=Apri%20il%20browser%20Edge%2C%20seleziona%20Impostazioni%20e%20altro%20%3E%20Impostazioni%20%3E,cui%20vuoi%20eliminare%20i%20cookie">Microsoft Edge: Guida</a></li>
                </ul>

                <p><strong>6. Modifiche alle Impostazioni</strong></p>
                <p>Le preferenze sui cookie possono essere aggiornate in qualsiasi momento accedendo alla sezione "Impostazioni Cookie". Le modifiche avranno effetto solo per le sessioni future.</p>

                <p><strong>7. Contatti</strong></p>
                <p>Per domande o dubbi relativi alle impostazioni dei cookie, è possibile contattarci all’indirizzo email: <a href="mailto:info@rossomotori.it">info@rossomotori.it</a>.</p>

            </div>
        </Wrapper>
    );
}

export default CookieSettings;